import NewsTipAdvancedView from './RejectReasonAdvancedView'

export default NewsTipAdvancedView
